import PropType from 'prop-types';
import React, { useEffect, useState } from 'react';

import { resendOTP, verifyOTP } from '../../services/services';
import {
  BOTH_CHANNEL_OTP_SENT,
  EMAIL_OTP_SENT,
  ENTER_OTP,
  MOBILE_OTP_SENT,
  OTP_CHANNEL,
  OTP_LENGTH,
  RESEND_OTP_TIMER,
} from '../../utils/consts';
import { Button } from '../Button';
import { InputText } from '../Input';

class ResendButton extends React.Component {
  timerInterval;

  constructor(props) {
    super(props);

    const { isResendDisabled } = props;
    this.state = {
      timer: 0,
      isResendDisabled: isResendDisabled,
      resendLimit: 3,
    };

    this.startTimer = this.startTimer.bind(this);
  }

  componentDidMount() {
    this.startTimer();
  }

  componentDidUpdate(prevProps) {
    const { isResendDisabled } = this.props;

    if (isResendDisabled !== prevProps.isResendDisabled) {
      this.setState({
        isResendDisabled: isResendDisabled,
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  }

  startTimer() {
    let timerLimit = RESEND_OTP_TIMER;
    this.setState({ isResendDisabled: true });
    this.timerInterval = setInterval(() => {
      if (timerLimit === 0) {
        clearInterval(this.timerInterval);
      }
      this.setState({ timer: timerLimit-- });

      const { resendLimit } = this.state;
      if (timerLimit === -1 && resendLimit > 0) {
        this.setState({ isResendDisabled: false });
      }
    }, 1000);
  }

  render() {
    const { partnerTransactionId, otpTransactionId, onResendOTPSuccess } = this.props;
    const { timer, isResendDisabled } = this.state;
    return (
      <Button
        buttonType="tertiary"
        disabled={isResendDisabled}
        onClick={() => {
          this.startTimer();
          this.setState(prevState => ({
            resendLimit: prevState.resendLimit - 1,
          }));
          resendOTP({
            partnerTransactionId,
            otpTransactionId,
            otpType: 'New',
          })
            .then(res => {
              onResendOTPSuccess(res);
            })
            .catch(err => {
              onResendOTPSuccess(err);
            });
        }}
        progress={timer / RESEND_OTP_TIMER}>
        {`Resend OTP ${timer !== 0 ? `(${timer})` : ''} `}
      </Button>
    );
  }
}

ResendButton.propTypes = {
  isResendDisabled: PropType.bool,
  partnerTransactionId: PropType.string,
  otpTransactionId: PropType.string,
  onResendOTPSuccess: PropType.func,
};

const OTPVerification = props => {
  const { initiatePaymentRes, closePopup, onOTPSuccess } = props;

  const [otpTransactionId, setOtpTransactionId] = useState();
  const [partnerTransactionId, setPartnerTransactionId] = useState();
  const [noActionAllowed, setNotActionAllowed] = useState(false);

  const [otp, setOTP] = useState('');
  const [error, setError] = useState('');
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= 767 ? true : false);

  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const onOTPChange = event => {
    let pat = /^[0-9]*$/;
    let str = event.target.value.replace(/[' ']/g, '');

    if (str.length > 6 || !pat.test(str)) {
      return false;
    }
    if (str.length === 6) {
      setError(null);
    }
    setOTP(str);
  };

  const onOTPBlur = event => {
    let errorMsg = null;

    if (event.target.value === '') {
      errorMsg = ENTER_OTP;
    } else if (event.target.value.length !== 6) {
      errorMsg = OTP_LENGTH;
    }

    setError(errorMsg);
  };

  const onOTPPaste = e => {
    e.preventDefault();
    return false;
  };

  // Function for getting screen width & update the isMobileView state
  const updateDimensions = () => {
    if (window.innerWidth <= 767) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  const showToastMessage = (msg, msgType) => {
    setToastMessage(msg);
    setToastMessageType(msgType);
    document.addEventListener('click', removeToastMessage);
    document.addEventListener('keydown', removeToastMessage);
  };

  const removeToastMessage = () => {
    setToastMessage('');
    setToastMessageType('');
    document.removeEventListener('click', removeToastMessage);
    document.removeEventListener('keydown', removeToastMessage);
  };

  const otpSuccessMessage = channel => {
    let msg = '';
    if (channel === OTP_CHANNEL.EMAIL) {
      msg = EMAIL_OTP_SENT;
    } else if (channel === OTP_CHANNEL.MOBILE) {
      msg = MOBILE_OTP_SENT;
    } else if (channel === OTP_CHANNEL.EMAIL_MOBILE) {
      msg = BOTH_CHANNEL_OTP_SENT;
    }
    showToastMessage(msg, 'success');
  };

  useEffect(() => {
    if (initiatePaymentRes.otpTransactionId) {
      setOtpTransactionId(initiatePaymentRes.otpTransactionId);
    }
    if (initiatePaymentRes.partnerTransactionId) {
      setPartnerTransactionId(initiatePaymentRes.partnerTransactionId);
    }
    otpSuccessMessage(initiatePaymentRes.channel);
  }, [initiatePaymentRes]);

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);

    return () => {
      document.removeEventListener('click', removeToastMessage);
      document.removeEventListener('keydown', removeToastMessage);
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  const onResendOTPSuccess = res => {
    if (res && res.data && res.code === 600) {
      otpSuccessMessage(res.data.channel);
      setOtpTransactionId(res.data.otpTransactionId);
      setPartnerTransactionId(res.data.partnerTransactionId);
    } else if (res && res.errorMsg) {
      showToastMessage(res.errorMsg, 'error');
    } else {
      showToastMessage('Something went wrong', 'error');
    }
  };

  const disableVerfiyBtn = () => {
    let disable = true;
    if (otp && otp.length === 6 && !error) {
      disable = false;
    }
    return disable;
  };

  const verifyBtnClick = () => {
    setNotActionAllowed(true);
    verifyOTP({
      paymentId: initiatePaymentRes.paymentId,
      PartnerTransactionID: partnerTransactionId,
      OtpTransactionID: otpTransactionId,
      otpValue: otp,
      channel: initiatePaymentRes.channel,
    })
      .then(res => {
        setNotActionAllowed(false);
        if (res && res.code === 800) {
          setNotActionAllowed(true);
        }
        if (res && res.data && res.code === 600) {
          otpSuccessMessage(res.data.channel);
          onOTPSuccess();
        } else if (res && res.errorMsg) {
          showToastMessage(res.errorMsg, 'error');
        } else {
          showToastMessage('Something went wrong', 'error');
        }
      })
      .catch(() => {
        setNotActionAllowed(false);
        showToastMessage('Something went wrong', 'error');
      });
  };

  return (
    <React.Fragment>
      <div className="spm_overlay spm_modal_overlay">
        <div className="ReactModal__Overlay ReactModal__Overlay--after-open otp-overlay">
          <div className="ReactModal__Content ReactModal__Content--after-open">
            <div className="insufficient_miles_wrapper">
              <div role="alert" aria-live="polite" aria-atomic="true" id="serverSideErrors2FA">
                {toastMessage && (
                  <div className={`toast-message-container ${toastMessageType}`}>
                    <div className="text-view-container center">
                      <div className="text-container center">
                        <span className="text body_14 bold">{toastMessage}</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="flex_row">
                <h4 className="heading">OTP Verification</h4>
                <div className="jp-popup-close-btn">
                  <button type="button" id="btnclose" onClick={closePopup}></button>
                </div>
              </div>
              <div className="jp-modal-details  jp-position-relative" aria-label="Verify your mobile">
                <div className="status_text">
                  <p>
                    {initiatePaymentRes.channel === OTP_CHANNEL.EMAIL && EMAIL_OTP_SENT}
                    {initiatePaymentRes.channel === OTP_CHANNEL.MOBILE && MOBILE_OTP_SENT}
                    {initiatePaymentRes.channel === OTP_CHANNEL.EMAIL_MOBILE && BOTH_CHANNEL_OTP_SENT}
                  </p>
                </div>
                <form className="otp-form">
                  <InputText
                    label="ENTER YOUR OTP"
                    id="txtOTP"
                    type="text"
                    name="txtOTP"
                    value={otp}
                    onChange={onOTPChange}
                    onBlur={onOTPBlur}
                    aria-label="ENTER YOUR OTP"
                    onPaste={onOTPPaste}
                    aria-required="true"
                    aria-describedby="otp"
                    msgText={error}
                    messageMode={error ? 'error' : undefined}
                    isMobile={isMobile}
                  />
                  <ResendButton
                    isResendDisabled={noActionAllowed}
                    otpTransactionId={otpTransactionId}
                    partnerTransactionId={partnerTransactionId}
                    onResendOTPSuccess={onResendOTPSuccess}
                  />
                </form>
              </div>
              <div className="footer_section">
                <div className="button_container">
                  <div className="jp-button-container">
                    <Button
                      disabled={noActionAllowed || disableVerfiyBtn()}
                      className="jp-button primary no_text_transform"
                      onClick={verifyBtnClick}>
                      VERIFY
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

OTPVerification.propTypes = {
  initiatePaymentRes: PropType.object,
  closePopup: PropType.func,
  onOTPSuccess: PropType.func,
};

export default OTPVerification;
